'use client';
import { ProductReference, ProductVariant } from "lib/shopify/types";
import { cn } from "utils/cn";

export function VariantSelector({product, selectedVariant, action}: {product: ProductReference, selectedVariant: ProductVariant, action: (variant: ProductVariant) => void}) {
    const edgelessColors = product.colors?.references.edges.map((edge) => edge.node);
    if (!edgelessColors) return null;
    const variants = product.variants.edges.map((edge) => edge.node);
    return (
        <div className='flex flex-col justify-center items-center'>
            {/* <div>Colors:</div> */}
            <div className='flex'>
                {edgelessColors.map(
                    (color) => {
                        const currentColor = color.fields.find((field) => field.key === 'color')?.value;
                        const currentLabel = color.fields.find((field) => field.key === 'label')?.value
                        const findVariant = variants.find((variant) => variant.title === currentLabel)!
                        return(
                            <button 
                                key={`${color.handle}`} 
                                onClick={()=> action(findVariant)} 
                                aria-label={`Select ${currentLabel} color variant`}
                                className={cn('mx-2 my-1 flex size-9 items-center justify-center rounded-full border bg-neutral-100 px-2 py-2 text-sm dark:border-neutral-800 dark:bg-neutral-900', {
                                    'cursor-default ring-2 ring-blue-600': selectedVariant?.title === currentLabel
                                })}
                            >
                                <div className='size-5 rounded-full' style={{backgroundColor: currentColor}}>
                                </div> 
                            </button>
                        )
                    }
                )}
            </div>
            <span className='ml-2'>{edgelessColors.find(color => color.fields.find(field => field.key === 'label')?.value === selectedVariant?.title)?.fields.find(field => field.key === 'label')?.value}</span>
        </div>
    )
}
